import { Checkbox, CheckboxProps, Divider } from 'antd'
import { forwardRef, useEffect, useImperativeHandle, useState } from 'react'
import styles from '../../index.module.less'
const CheckboxGroup = Checkbox.Group
const ConfigCheck = forwardRef((props: any, ref) => {
  const { list, defaultCheckList } = props
  useEffect(() => {
    console.log(defaultCheckList);
    setCheckedList([...defaultCheckList])
  },[defaultCheckList])
  const [checkedList, setCheckedList] = useState<string[]>([])
  const checkAll = list.length === checkedList.length
  const indeterminate = checkedList.length > 0 && checkedList.length < list.length

  const onChange = (val: string[]) => {
    setCheckedList(val)
  }

  const onCheckAllChange: CheckboxProps['onChange'] = e => {
    setCheckedList(e.target.checked ? list.map((item: any) => item.value) : [])
  }

  useImperativeHandle(ref, () => ({
    // 获取选中的值
    getCheckedList: checkedList,
  }))
  return (
    <div className={styles.configCheck}>
      <Checkbox
        style={{ marginBottom: 8 }}
        indeterminate={indeterminate}
        onChange={onCheckAllChange}
        checked={checkAll}
      >
        全选
      </Checkbox>
      <CheckboxGroup options={list} value={checkedList} onChange={onChange} />
    </div>
  )
})

export default ConfigCheck
